module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-KX5200.6bb16db2.png";